(()=>{
  const q=(s,c=document)=>c.querySelector(s);
  const qa=(s,c=document)=>Array.from(c.querySelectorAll(s));

  qa('[data-cs-premiere]').forEach(section=>{
    const slides=qa('[data-premiere-slide]',section);
    const triggers=qa('[data-premiere-trigger]',section);
    if(!slides.length||!triggers.length)return;
    let current=0;
    let timer=null;
    const autoplay=section.dataset.autoplay==='true';

    const activate=(index)=>{
      current=(index+slides.length)%slides.length;
      slides.forEach((slide,i)=>{
        const active=i===current;
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',active?'false':'true');
      });
      triggers.forEach((trigger,i)=>{
        const active=i===current;
        trigger.classList.toggle('is-active',active);
        trigger.setAttribute('aria-selected',active?'true':'false');
      });
    };

    const stop=()=>{if(timer){window.clearInterval(timer);timer=null;}};
    const start=()=>{
      stop();
      if(autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
        timer=window.setInterval(()=>activate(current+1),6500);
      }
    };

    triggers.forEach((trigger,i)=>{
      trigger.addEventListener('click',()=>{activate(i);start();});
      trigger.addEventListener('focus',()=>activate(i));
    });
    section.addEventListener('mouseenter',stop);
    section.addEventListener('mouseleave',start);
    activate(0);
    start();
  });
})();
